import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Icon from 'dpl/common/components/Icon';
import { isMobileUA } from 'dpl/shared/utils';
import MiniOverlayModal from 'dpl/common/mini_overlay_modal/components/MiniOverlayModal';
import TooltipWrapper from 'dpl/common/tooltip/components/TooltipWrapper';
import { TOOLTIP_VARIANTS } from 'dpl/common/utils/constants';
import { isGreaterThanBreakpoint } from 'dpl/util/grid';

import StripeChargeModalFixedTooltipWrapper from './StripeChargeModalFixedTooltipWrapper';

const IS_GT_LG = isGreaterThanBreakpoint('lg');

export default function StripeChargeModalIconRenderWrapper({
  tooltipProps,
  iconProps,
  modalProps,
  desktopTooltipProps
}) {
  const isMobile = isMobileUA();
  const [isModalOpen, setModalOpen] = useState(false);

  if (!tooltipProps && !modalProps) {
    return <Icon {...iconProps} />;
  }

  function handleOpenness(isOpen) {
    modalProps?.onVisibilityChanged?.(isOpen) ?? setModalOpen(isOpen);
  }

  if (!isMobile && modalProps) {
    const displayModal = modalProps.isVisible ?? isModalOpen;
    return (
      <>
        {desktopTooltipProps && IS_GT_LG ? (
          <TooltipWrapper
            variant={TOOLTIP_VARIANTS.MIDNIGHT}
            title={desktopTooltipProps.title}
            minWidth="226px"
            disablePositionReset
          >
            <button
              type="button"
              id={iconProps.buttonId}
              data-test-id={iconProps.buttonId ?? 'line-item-button-icon'}
            >
              <Icon name={iconProps.name} />
            </button>
          </TooltipWrapper>
        ) : (
          <button
            type="button"
            id={iconProps.buttonId}
            data-test-id={iconProps.buttonId ?? 'line-item-button-icon'}
            onClick={() => handleOpenness(true)}
          >
            <Icon name={iconProps.name} />
          </button>
        )}
        {displayModal && (
          <MiniOverlayModal
            maxWidth={modalProps.maxWidth ?? '400px'}
            onCloseClick={() => handleOpenness(false)}
          >
            {modalProps.content}
          </MiniOverlayModal>
        )}
      </>
    );
  }

  return (
    <StripeChargeModalFixedTooltipWrapper
      title={tooltipProps.title}
      {...tooltipProps}
    >
      <Icon name={iconProps.name} />
    </StripeChargeModalFixedTooltipWrapper>
  );
}

StripeChargeModalIconRenderWrapper.propTypes = {
  iconProps: PropTypes.shape({
    name: PropTypes.string.isRequired,
    renderFunction: PropTypes.func,
    buttonId: PropTypes.string
  }).isRequired,
  tooltipProps: PropTypes.shape({
    title: PropTypes.node.isRequired,
    className: PropTypes.string,
    minWidth: PropTypes.string,
    isVisible: PropTypes.bool
  }),
  modalProps: PropTypes.shape({
    maxWidth: PropTypes.string,
    content: PropTypes.node.isRequired,
    isVisible: PropTypes.bool,
    onVisibilityChanged: PropTypes.func
  }),
  desktopTooltipProps: PropTypes.shape({
    title: PropTypes.node.isRequired
  })
};

StripeChargeModalIconRenderWrapper.defaultProps = {
  tooltipProps: null,
  modalProps: null,
  desktopTooltipProps: null
};
